import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../api'

const addReport = async (
  type: string,
  target: string,
  text: string,
  postId: string,
) => {
  if (!text) {
    throw new Error('Comment should not be empty')
  }
  const { data: userData } = await supabase.auth.getSession()

  const { data: reportData, error } = await supabase
    .from('reports')
    .insert({
      type,
      target,
      text,
      creator_user_id: userData?.session?.user?.id,
      post_id: postId,
    })
    .select()
    .single();

  if (error) {
    throw new Error(error.message)
  }

  return reportData
}

export default function useAddReport(
  type: string,
  target: string,
  text: string,
  postId: string,
) {
  const queryClient = useQueryClient()

  return useMutation(() => addReport(type, target, text, postId), {
    onSuccess: async (res) => {
      queryClient.invalidateQueries({ queryKey: ['reports'] })
      return res
    },
  })
}
